import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import UserHeader from "../../Component/UserHeader";
import UserSidebar from "../../Component/UserSidebar";
import * as settingActions from "../../actions/settingActions";
import * as baseActions from "../../actions/baseActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import StudentSignup from "./UpdateProfileStep14";
import PropTypes from "prop-types";


function SidebarAddClass() {
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}
const UpdateProfile3 = (props) => {

  useEffect(() => {
    document.title = props?.title
  }, [props])

  return (
    <div>
      <UserHeader />

      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to="#"
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h2 className="page_heading mb-3">Complete/ Edit Profile</h2>

          <div className="box shadow bg-white p-md-5">
            <div className="studentformdashboard pt-md-4">
              <StudentSignup type='profile' />
            </div>
          </div>
        </div>
      </div>
      <input
        type="button"
        className="sidebar_overlay"
        onClick={SidebarRemoveClass}
        aria-label="Close sidebar overlay"
      />
    </div>
  );
};


function mapStateToProps(state) {
  return {
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {...settingActions,
        ...baseActions
      },
      dispatch
    ),
  };
}

UpdateProfile3.propTypes = {
  title: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile3);

